import { Captions, SmallSectionHeader, ShortBody } from 'components/Typography';
import React from 'react';
import styled from 'styled-components';
import { Divider } from '@material-ui/core';

export const SizedSmallSectionHeader = styled(SmallSectionHeader)`
  && {
    letter-spacing: 0;
    line-height: 23px;
  }
`;

export const SizedCaptions = styled(Captions)`
  &&& {
    font-size: 13px !important;
    line-height: 20px;
    margin-bottom: 0px;
  }
`;

export const StyledShortBody = styled(({ isSelected, ...otherProps }) => (
  /* istanbul ignore next */ <ShortBody {...otherProps} />
))`
  &&& {
    color: ${/* istanbul ignore next */ ({ isSelected }) =>
      isSelected ? '#0075C9' : '#162952'};
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 17px;
    margin-bottom: 0px;
    margin-top: 0px;
  }
`;

export const ColoredDivider = styled(Divider)`
  && {
    background-color: #979797;
    opacity: 24%;
  }
`;
